import { Feature } from '../common'
import { PAGES } from '../../constants/GLOBAL_VARIABLE'

const DROPS_TARGET = 'chzzk'

export default class ChzzkLinking extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'ial', enumKey: 'IAL.CHZZK_LINKING' })
    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    // persistent values
    const {
      gid,
      redirect_uri: redirectUri,
      support_platforms: supportPlatforms,
    } = this.queryParamWithCookie

    // one-time values
    const {
      link_ticket: linkTicket,
      chzzk_code: chzzkCode,
      state,
    } = this.queryParam

    this.gid = gid
    this.target = DROPS_TARGET
    this.redirectUri = redirectUri
    this.supportPlatforms = supportPlatforms
    this.linkTicket = linkTicket
    this.chzzkCode = chzzkCode
    this.state = state

    console.debug('[ChzzkLinking Instance]', this)
  }

  get hasLinkTicket() {
    return !!this.linkTicket
  }

  setCookie() {
    const cookieData = {
      gid: this.gid,
      target: this.target,
      redirect_uri: this.redirectUri,
      support_platforms: this.supportPlatforms,
      link_ticket: this.linkTicket,
      chzzk_code: this.chzzkCode,
      state: this.state,
    }
    this.namespaceCookie.setCookie(cookieData)
  }

  clearCookie() {
    this.namespaceCookie.clearCookie()
  }

  saveReferrer() {
    const redirect = this.redirectUri ? decodeURIComponent(this.redirectUri) : ''

    if (!(redirect || document.referrer)) return

    const url = new URL(redirect || document.referrer)
    const referrer = url.toString()
    this.redirectUri = referrer
  }

  gotoPlatformSelectorPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_CHZZK_PLATFORM_SELECTOR}`)
  }

  gotoAccountInfoPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_CHZZK_ACCOUNT_INFO}`)
  }

  processLinking() {
    this.clearCookie()
    this.saveReferrer()
    this.setCookie()

    if (this.hasLinkTicket) {
      this.gotoPlatformSelectorPage()
    } else {
      this.gotoAccountInfoPage()
    }
  }
}
